import { Link } from "wouter";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#111111] border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 pb-36 sm:pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="space-y-4">
            <div>
              <img src="/logo.webp" alt="Gorilla Works Marketing" width="224" height="56" loading="lazy" decoding="async" className="h-14 w-auto" />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              The most advanced direct mail and print marketing platform. Powered by AI analytics to dominate your local market.
            </p>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Mail aria-hidden="true" className="w-4 h-4 text-primary flex-shrink-0" />
              <a href="mailto:hello@gorillaworksmarketing.com" className="break-all hover:text-primary transition-colors">hello@gorillaworksmarketing.com</a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-bold text-foreground uppercase tracking-wider mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link href="/print-shop/postcards" className="text-sm text-muted-foreground hover:text-primary transition-colors">Postcards</Link></li>
              <li><Link href="/print-shop/sheets" className="text-sm text-muted-foreground hover:text-primary transition-colors">8.5" x 11" Sheets</Link></li>
              <li><Link href="/pricing" className="text-sm text-muted-foreground hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link href="/quote" className="text-sm text-muted-foreground hover:text-primary transition-colors">Request a Quote</Link></li>
              <li><Link href="/causal-analytics" className="text-sm text-muted-foreground hover:text-primary transition-colors">Causal Analytics</Link></li>
              <li><Link href="/integrations" className="text-sm text-muted-foreground hover:text-primary transition-colors">Integrations</Link></li>
              <li><Link href="/services/direct-mail" className="text-sm text-muted-foreground hover:text-primary transition-colors">Direct Mail</Link></li>
              <li><Link href="/services/website-development" className="text-sm text-muted-foreground hover:text-primary transition-colors">Website Development</Link></li>
              <li><Link href="/services/seo" className="text-sm text-muted-foreground hover:text-primary transition-colors">SEO</Link></li>
              <li><Link href="/services/google-meta-ads" className="text-sm text-muted-foreground hover:text-primary transition-colors">Google &amp; Meta Ads</Link></li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-sm font-bold text-foreground uppercase tracking-wider mb-4">Industries</h3>
            <ul className="space-y-2">
              {["Roofing", "HVAC", "Lawn Care", "Pest Control", "Restaurants", "Construction", "Landscaping", "Painting"].map((ind) => (
                <li key={ind}>
                  <Link href={`/industries/${ind.toLowerCase().replace(/ /g, "-")}`} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                    {ind}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-bold text-foreground uppercase tracking-wider mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link href="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">About Us</Link></li>
              <li><Link href="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">Contact</Link></li>
              <li><Link href="/industries" className="text-sm text-muted-foreground hover:text-primary transition-colors">All Industries</Link></li>
              <li><Link href="/sign-up" className="text-sm text-muted-foreground hover:text-primary transition-colors">Create Account</Link></li>
              <li><Link href="/sign-in" className="text-sm text-muted-foreground hover:text-primary transition-colors">Sign In</Link></li>
              {import.meta.env.DEV && (
                <li><Link href="/__blog-preview" data-testid="footer-blog-preview" className="text-sm text-muted-foreground hover:text-primary transition-colors">Blog template preview</Link></li>
              )}
              <li><a href="/blog" data-testid="footer-blog" className="text-sm text-muted-foreground hover:text-primary transition-colors">Blog</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Gorilla Works Marketing. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center items-center gap-4">
            <button type="button" onClick={() => window.dispatchEvent(new Event("gorilla-privacy-open"))} className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Your Privacy Choices / Do Not Sell or Share
            </button>
            <p className="text-xs text-muted-foreground">AI-Powered Direct Mail Platform</p>
            <a
              href="/privacy/"
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="/terms/"
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              Terms of Service
            </a>
            <a
              href="/data-deletion/"
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              Data Deletion
            </a>
            <a
              href="/sitemap.xml"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
